

import React, { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import './Notification.css';

const Notification = ({
  show,
  message,
  type = 'success',
  duration = 3000,
  onClose,
  containerClassName = '',
}) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
    
    if (show && duration > 0) {
      const timer = setTimeout(() => {
        setVisible(false);
        if (onClose) onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  if (!visible) return null;

  return (
    <div
      className={`notification-container${containerClassName ? ` ${containerClassName}` : ''}`}
    >
      <Alert 
        variant={type} 
        dismissible 
        onClose={() => {
          setVisible(false);
          if (onClose) onClose();
        }}
        className="notification-alert"
      >
        {message}
      </Alert>
    </div>
  );
};

export default Notification;
